/* eslint-disable @typescript-eslint/no-magic-numbers */
import { Alphabet } from '../types/alphabet';

type SpecialKeyboardKey =
   | `f${1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}`
   | 'escape'
   | 'backspace'
   | 'enter'
   | 'space'
   | 'arrowUp'
   | 'arrowDown'
   | 'arrowLeft'
   | 'arrowRight'
   | 'delete'
   | 'insert'
   | 'home'
   | 'end'
   | 'pageUp'
   | 'pageDown';
type KeyboardEvent = {
   ctrlKey: boolean;
   shiftKey: boolean;
   altKey: boolean;
   metaKey: boolean;
   key: string;
};
type KeyboardKey = Alphabet | SpecialKeyboardKey;
const MODIFIER_KEYS = ['ctrl', 'shift', 'alt', 'meta'] as const;
type ModifierKeyboardKey = typeof MODIFIER_KEYS[number];
export type KeyCombination =
   | `${ModifierKeyboardKey}+${KeyboardKey}`
   | `${ModifierKeyboardKey}+${KeyboardKey}`
   | KeyboardKey;

export const isKeyCombination = (event: KeyboardEvent, combination: KeyCombination): boolean => {
   const keys = combination
      .toLowerCase()
      .split('+')
      .map((key) => key.trim());

   const ctrlPressed = keys.includes('ctrl') === event.ctrlKey;
   const shiftPressed = keys.includes('shift') === event.shiftKey;
   const altPressed = keys.includes('alt') === event.altKey;
   const metaPressed = keys.includes('meta') === event.metaKey;

   const mainKey = keys.pop();
   const mainKeyPressed = mainKey ? event.key.toLowerCase() === mainKey : true;

   return ctrlPressed && shiftPressed && altPressed && metaPressed && mainKeyPressed;
};
